module.exports = __webpack_public_path__ + "exo-latin-100.f60defca0bb5c4a76c36.svg";


//////////////////
// WEBPACK FOOTER
// /srv/prod/FitRadioAdmin2/node_modules/typeface-exo/files/exo-latin-100.svg
// module id = ../../../../typeface-exo/files/exo-latin-100.svg
// module chunks = styles